export function getScoreDelta(rawScore, delta) {
  const scoreBefore = rawScoreToScaledScore(rawScore)
  const scoreAfter = rawScoreToScaledScore(rawScore + delta)
  return Math.round(10 * (scoreAfter - scoreBefore)) / 10
}

export function rawScoreToScaledScore(rawScore) {
  const lnScore = Math.log(1 + rawScore)
  const sigmoid = 1 / (1 + Math.exp(-(lnScore - 5) / 1.5))
  const scaled = 1 + 99 * sigmoid
  return Math.round(10 * scaled) / 10
}
